export default __webpack_public_path__ + "media/images/elephant_ui_working-72f79b68dc4b9c8022185551520ba81d.svg";